<script setup>
import { inject, computed } from 'vue';
import SchoolPage from '@/components/result/ai-literacy-2026/SchoolPage.vue';

// 부모 컴포넌트에서 전달받은 데이터
const principalData = inject('principalData');

</script>


<template>
  <!-- SchoolPage.vue가 자체적으로 .report-inner를 렌더한다. 여기서 한 번 더 감싸면
       .report-inner(높이 1460px 고정)가 중첩돼 내용 크기와 무관하게 페이지가 항상
       1460px+padding으로 측정되는 버그가 생긴다. -->
  <SchoolPage
          reportType="principal"
          :reportData="principalData"
      />
</template>

<style lang="scss" scoped>

</style>